import { createAction } from 'redux-act';

export const handleError = createAction('Handle error');
export const setError = createAction('Set error');
export const setErrorStatus = createAction('Set Error status');

export const errorRedirect = createAction('Redirect to error page');
export const errorReset = createAction('Reset error');
